
import domready from '../utils/domready.js';

  function showHideLabel (input, inputContainer) {
    if (input.value.length) {
      inputContainer.classList.add('input--filled');
    } else {
      inputContainer.classList.remove('input--filled');
    }
  }

  domready(function() {
    var inputContainers = Array.prototype.slice.call(document.querySelectorAll('.input--label-floating'));
    inputContainers.forEach(function(inputContainer) {
      inputContainer.addEventListener('input', function(event) {
        showHideLabel(event.target, inputContainer);
      });
      showHideLabel(inputContainer.querySelector('.input__field'), inputContainer);
    })
  });
